import React from 'react';

export const useConfirmExit = (message?: string, blockCallback?: () => {}) => {
  const [block, setBlock] = React.useState<boolean>(false);
  const [_callback, setCallback] = React.useState<any>();

  const confirmExit = event => {
    event.preventDefault();
    _callback?.();
    return (event.returnValue = message ?? 'Are you sure');
  };

  React.useEffect(() => {
    if (block) {
      window.addEventListener('beforeunload', confirmExit);
    } else {
      window.removeEventListener('beforeunload', confirmExit);
    }
    return () => {
      window.removeEventListener('beforeunload', confirmExit);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [block]);

  const blockExit = (callback?: () => void) => {
    setBlock(true);
    if (callback) {
      setCallback(callback);
    }
  };

  const allowExit = () => {
    setBlock(false);
  };

  return { blockExit, allowExit };
};